export default "__VITE_ASSET__sEo52yHU__"